import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import performRequest from "../../api/request";
import { FcShop } from "react-icons/fc";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import { CreateFarmerOrder } from "../../Schemas/Farm support/farmer_shop_schema";
import { FarmerShopInfo } from "../../SchemaInfo/info";
import { Form, Formik } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import { IoMdAdd } from "react-icons/io";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";

const FarmerShop = () => {
  let role = useSelector((store) => store?.login?.user);
  const [refresh, setRefresh] = useState(false);
  const [city, setCity] = useState();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [filters, setFilters] = useState({
    sortByPrice: "",
    availableStock: "",
    category: "",
  });
  const [addressData, setAddressData] = useState();
  useEffect(() => {
    if (role && role.Role === process.env.REACT_APP_ROLE_CLIENT) {
      if (role.AdditionalRole !== "farmer partner") {
        navigate("/");
      }
    }
  }, [role]);
  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/accessories/all-fa-shop-accessories", 1, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  useEffect(() => {
    performRequest("GET", "/pmg/address/all-address")
      .then((res) => {
        if (res.status === 200) {
          setAddressData(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/pmg/cities/all-cities")
      .then((res) => {
        if (res.status === 201) {
          setCity(res?.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = async (values) => {
    values = { ...values, orderType: "farmer to cnf", orderTo: 2 };
    performRequest("POST", "/pmg/fa-orders/create-fa-order", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Item ordered successfully!");
          navigate("/farm-order");
        } else {
          Toast("error", "Error while creating order!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const handleQuantityChange = (value, setFieldValue, price) => {
    setFieldValue("quantity", value);
    setFieldValue("totalAmount", value * price);
  };

  const handleCityChange = (cityName, setFieldValue) => {
    const selectedCity = city?.allCityData?.find((c) => c.city === cityName);
    if (selectedCity) {
      setFieldValue("shippingAddress.city", selectedCity.city);
      setFieldValue("shippingAddress.pincode", selectedCity.pincode);
      setFieldValue("shippingAddress.state", selectedCity.state);
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none m-0">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcShop className="fs-2  me-1" />
                  Farmer Shop
                </h2>
                <h4 className="text-muted m-0 p-0">Order items from shop.</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Price:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByPrice: e.target.value,
                                })
                              }
                              value={filters.sortByPrice}
                            >
                              <option value="">Select</option>
                              <option value="asc">Low to high</option>
                              <option value="desc">High to low</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Avilable stock:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  availableStock: e.target.value,
                                })
                              }
                              value={filters.availableStock}
                            >
                              <option value="">Select</option>
                              <option value="asc">Low to high</option>
                              <option value="desc">High to low</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Category:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  category: e.target.value,
                                })
                              }
                              value={filters.category}
                            >
                              <option value="">Select</option>
                              <option value="HYDROPONIC PRODUCT">
                                Hydroponic Product
                              </option>
                              <option value="PLANT SEEDS">Plant Seeds</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      availableStock: "",
                                      sortByPrice: "",
                                      category: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Price:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByPrice: e.target.value,
                              })
                            }
                            value={filters.sortByPrice}
                          >
                            <option value="">Select</option>
                            <option value="asc">Low to high</option>
                            <option value="desc">High to low</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Avilable stock:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                availableStock: e.target.value,
                              })
                            }
                            value={filters.availableStock}
                          >
                            <option value="">Select</option>
                            <option value="asc">Low to high</option>
                            <option value="desc">High to low</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Category:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                category: e.target.value,
                              })
                            }
                            value={filters.category}
                          >
                            <option value="">Select</option>
                            <option value="HYDROPONIC PRODUCT">
                              Hydroponic Product
                            </option>
                            <option value="PLANT SEEDS">Plant Seeds</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    availableStock: "",
                                    sortByPrice: "",
                                    category: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/Av-YMT8vNIE"}
                  id={"model-viedo"}
                  name={'farmer shop'}
                ></CustomViedoCard>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="row row-deck">
                {data?.map((item) => (
                  <div
                    className={`col-md-4 col-6 mb-4 ${
                      item.quantity === 0 ? "disabled-card" : ""
                    }`}
                    key={item?.id}
                  >
                    <div
                      className={`card h-100 d-flex flex-column ${
                        item.quantity === 0 ? "text-muted" : ""
                      }`}
                      style={
                        item.quantity === 0
                          ? { pointerEvents: "none", opacity: 0.6 }
                          : {}
                      }
                    >
                      <div className="text-center mt-3">
                        <img
                          src={item?.photo}
                          className="me-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                          }}
                          alt="Item"
                        />
                        <p className="ms-2 me-2 mb-0 mt-2">{item?.name}</p>
                      </div>
                      <div className="card-body d-flex flex-column mt-0">
                        <b className="text-bold mb-2 fs-3 text-center">
                          Price per unit :{" "}
                          <span style={{ color: "rgb(12, 131, 31)" }}>
                            ₹{item?.price}
                          </span>
                        </b>
                        <p className="mb-1 text-center">MOQ : {item?.moq}</p>
                        <p className="mb-1 text-center">
                          Price per MOQ : ₹{item?.pricePerMoq}
                        </p>
                        <p
                          className={`fw-bold mt-2 ${
                            item.quantity > 0 ? "text-success" : "text-danger"
                          } text-center`}
                        >
                          {item?.quantity > 0
                            ? `${item?.quantity} Available`
                            : "Currently Out of Stock"}
                        </p>
                        <div className="mt-auto">
                          <button
                            className={`btn w-100 ${
                              item?.quantity > 0
                                ? "btn-success"
                                : "btn-secondary"
                            }`}
                            style={{
                              borderRadius: "8px",
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                            data-bs-toggle="modal"
                            data-bs-target={`#modal-${item.id}`}
                          >
                            {item?.quantity > 0 ? `Order Now` : "Not Available"}
                          </button>
                        </div>
                        <div
                          className="modal modal-blur fade"
                          id={`modal-${item.id}`}
                          tabIndex="-1"
                          role="dialog"
                          aria-hidden="true"
                        >
                          <Formik
                            initialValues={{
                              ...FarmerShopInfo,
                              accId: item?.id,
                            }}
                            validationSchema={CreateFarmerOrder}
                            onSubmit={handelSubmit}
                            enableReinitialize
                          >
                            {(props) => (
                              <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
                                <div
                                  className="modal-dialog modal-dialog-centered w-100"
                                  role="document"
                                >
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">Order</h5>
                                      <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                      ></button>
                                    </div>
                                    <div className="modal-body">
                                      {/* Quantity */}
                                      <div className="mb-3 row d-flex">
                                        <div className="w-50">
                                          <label className="form-label required">
                                            Quantity
                                          </label>
                                          <div className="w-100 col">
                                            <CustomInput
                                              name="quantity"
                                              type="text"
                                              onChange={(e) =>
                                                handleQuantityChange(
                                                  e.target.value,
                                                  props.setFieldValue,
                                                  item.price
                                                )
                                              }
                                            />
                                            {props.touched.quantity &&
                                              props.errors.quantity && (
                                                <p className="text-danger">
                                                  {props.errors.quantity}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                        <div className="mb-3 w-50">
                                          <label className="form-label required">
                                            Total Amount
                                          </label>
                                          <div className="ms-2 mt-2">
                                            ₹{props.values.totalAmount}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row w-100 d-flex">
                                        <div className="mb-3 w-50">
                                          <label className="form-label required">
                                            Select Address
                                          </label>
                                          <select
                                            className="form-select"
                                            onChange={(e) => {
                                              const selectedAddress =
                                                addressData.find(
                                                  (addr) =>
                                                    addr.id ===
                                                    parseInt(e.target.value)
                                                );
                                              if (selectedAddress) {
                                                // Set the form fields using Formik's setFieldValue
                                                props.setFieldValue(
                                                  "shippingAddress",
                                                  selectedAddress.shippingAddress
                                                );
                                              }
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select an address"
                                            />
                                            {addressData?.map((address) => (
                                              <option
                                                key={address.id}
                                                value={address.id}
                                              >
                                                {
                                                  address.shippingAddress
                                                    .address
                                                }
                                                , {address.shippingAddress.city}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="mb-3 w-50 mt-4">
                                          <button
                                            className="btn btn-primary ms-5"
                                            data-bs-dismiss="modal"
                                            onClick={() =>
                                              navigate("/add-address")
                                            }
                                          >
                                            <IoMdAdd className="me-2" /> Add
                                            Address
                                          </button>
                                        </div>
                                      </div>

                                      {/* Address */}
                                      <div className="mb-3 row">
                                        <label className="form-label required">
                                          Address
                                        </label>
                                        <CustomTextArea
                                          name="shippingAddress.address"
                                          type="text"
                                        />
                                      </div>
                                      {/* Address  */}
                                      <div className="mb-3 row">
                                        <label className="form-label required">
                                          Select City
                                        </label>
                                        <select
                                          name="shippingAddress.city"
                                          className="form-select"
                                          value={
                                            props.values.shippingAddress.city
                                          }
                                          onChange={(e) => {
                                            handleCityChange(
                                              e.target.value,
                                              props.setFieldValue
                                            );
                                          }}
                                        >
                                          <option
                                            value=""
                                            label="Select city"
                                          />
                                          {city?.allCityData?.map((item) => (
                                            <option
                                              key={item.id}
                                              value={item.city}
                                            >
                                              {item.city}
                                            </option>
                                          ))}
                                        </select>
                                        {props.errors.shippingAddress?.city && (
                                          <p className="text-danger">
                                            {props.errors.shippingAddress.city}
                                          </p>
                                        )}
                                      </div>

                                      {/* Pincode */}
                                      <div className="mb-3 row w-100 d-flex">
                                        <div className="mb-3 w-50">
                                          <label className="form-label required">
                                            Pincode
                                          </label>
                                          <CustomInput
                                            name="shippingAddress.pincode"
                                            type="text"
                                          />
                                        </div>
                                        <div className="mb-3 w-50">
                                          <label className="form-label required">
                                            State
                                          </label>
                                          <CustomInput
                                            name="shippingAddress.state"
                                            type="text"
                                          />
                                        </div>
                                      </div>

                                      {/* State */}
                                      <div className="mb-3 row w-50"></div>
                                      <div className="modal-footer bg-transparent">
                                        <button
                                          type="button"
                                          className="btn me-auto disable"
                                          data-bs-dismiss="modal"
                                        >
                                          Close
                                        </button>
                                        <div className="btn-list justify-content-center">
                                          <button
                                            className="btn btn-primary"
                                            data-bs-dismiss="modal"
                                            onClick={() =>
                                              handelSubmit(props.values)
                                            }
                                          >
                                            Order Item
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="d-block d-lg-none d-md-none ms-2 me-2">
          <CustomViedoCard
            viedoLink={"https://www.youtube.com/embed/Av-YMT8vNIE"}
            id={"model-viedo2"}
            name={'farmer shop'}
          ></CustomViedoCard>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FarmerShop;
